import { call } from "actionware/lib/call";
import { onError, onSuccess } from "actionware/lib/listeners";
import { message } from "antd";
import * as R from "ramda";

import { authenticatedApiFetch } from "../../common/helpers";
import { history } from "../../store";
import { mapApplicationFromJson } from "./applicationMappers";

export function toggleApplicationApprovalModal(action) {
  return action;
}

export function toggleAppDetail(action) {
  return action;
}

export function approvalModalDetail(content) {
  return content;
}

export const getApplication = async (
  params = { status: "pending", page: 1, size: 10 }
) => {
  return await authenticatedApiFetch(
    "lender/application",
    "GET",
    params
  ).then((result) => {
    return {
      lists: R.map(mapApplicationFromJson, result.data ?? []),
      totalData: result.totalData,
    };
  });
};

export function resetApplication() {
  return;
}

export async function approval(params) {
  return await authenticatedApiFetch(
    "lender/approval",
    "POST",
    params
  ).then((result) => {
    return result;
  });
}

export async function downloadReport(params) {
  return await authenticatedApiFetch(
    "lender/report",
    "GET",
    params
  ).then((result) => result);
}

onSuccess(approval, ({ store: { dispatch, getState } }) => {
  const {
    router: { location },
  } = getState();
  message.success("Approval/Rejection success", 5);
  history.push(location.pathname);
  call(toggleApplicationApprovalModal);
});

onError(approval, ({ store: { dispatch, getState } }) => {
  const {
    router: { location },
  } = getState();
  message.error("Approval/Rejection failed.", 5);
  history.push(location.pathname);
  call(toggleApplicationApprovalModal);
});

export const getBorrowerDetails = async (params) => {
  return await authenticatedApiFetch(
    "borrower/details",
    "GET",
    params
  ).then((result) => {
    return {
      ...params,
      ...result.data,
    };
  });
};
